import { render, staticRenderFns } from "./Votes.vue?vue&type=template&id=0ca1fec8"
import script from "./Votes.vue?vue&type=script&lang=js"
export * from "./Votes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca1fec8')) {
      api.createRecord('0ca1fec8', component.options)
    } else {
      api.reload('0ca1fec8', component.options)
    }
    module.hot.accept("./Votes.vue?vue&type=template&id=0ca1fec8", function () {
      api.rerender('0ca1fec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Votes.vue"
export default component.exports